import { ReactElement } from 'react';
import { Field, FieldProps } from 'formik';
import { TextField } from '@mui/material';

// Types
import { FormikTextFieldProps } from 'components/forms/types';

/**
 * FormikTextField Component
 * - This component is for use when FastFormickTextField isn't usable (ie. a property or callback is dependent on other form properties)
 *
 */
export const FormikTextField = ({ formikKey, inputProps, ...props }: FormikTextFieldProps): ReactElement => {
  return (
    <Field name={formikKey}>
      {({ field, meta }: FieldProps): ReactElement => {
        // formik supplies a field.onBlur that needs to be called - if props supplies one too, we need to call both
        const onBlur =
          field.onBlur && props.onBlur
            ? (...rest) => {
                field.onBlur.apply(this, rest);
                props.onBlur.apply(this, rest);
              }
            : (field.onBlur ?? props.onBlur);
        return (
          <TextField
            className="form-input"
            error={meta.touched && !!meta.error}
            helperText={meta ? meta.error : ''}
            id={field.name}
            name={field.name}
            onChange={field.onChange}
            value={field.value}
            {...field}
            {...props}
            onBlur={onBlur}
            slotProps={{ htmlInput: { ...inputProps, 'aria-label': field.name } }}
          />
        );
      }}
    </Field>
  );
};
